import { ButtonTransition } from './MuiButton';
// const cls = (s: string) => `.${s}`
var cellSize = 30;
export var spacingOffset = 2;
export var calendarWidth = 292; // design has 284 but then custom date picker with 4 fields will overflow
export var MuiPickersLayout = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                minWidth: calendarWidth,
                '.MuiDayCalendar-slideTransition': {
                    minHeight: 230, // Override default height - 230 is minimum height for 6 rows
                },
                '.MuiDateCalendar-root, .MuiPickersLayout-contentWrapper, .MuiMonthCalendar-root, .MuiYearCalendar-root': {
                    // Disable fixed width from mui, and apply min width instead for better responsiveness
                    width: 'auto',
                    minWidth: calendarWidth,
                    gap: theme.spacing(2),
                },
                // Hide divider between calendar and time picker
                '.MuiPickersLayout-contentWrapper > .MuiDivider-root': {
                    display: 'none',
                },
                '.MuiDayCalendar-weekDayLabel, .MuiPickersDay-root': {
                    width: cellSize,
                    height: cellSize,
                    fontSize: '0.75rem',
                    margin: '3px',
                },
                '.MuiDayCalendar-weekDayLabel': {
                    color: theme.palette.text.hint,
                    fontSize: theme.typography.caption.fontSize,
                },
                '.MuiPickersMonth-root, .MuiPickersYear-root': {
                    // 3 items per row
                    flex: '1 0 30%',
                    '& button': {
                        width: '100%',
                        margin: 0,
                    },
                    '& button.Mui-disabled': {
                        opacity: 0.4,
                    },
                },
                '.MuiPickersYear-root': {
                    // 4 items per row
                    flex: '1 0 21%',
                    maxWidth: '21%',
                },
                // Shared styles for day, month, and year buttons
                '.MuiPickersDay-root, .MuiPickersMonth-root button, .MuiPickersYear-root button': {
                    transition: ButtonTransition,
                    borderRadius: theme.shape.borderRadius,
                    color: theme.palette.text.primary,
                    fontSize: theme.typography.body1.fontSize,
                    padding: 0,
                    '&:focus': {
                        outlineStyle: 'solid',
                        // 1.5px looks better than 1px, because 1px looks like black ???
                        outlineWidth: '1.5px',
                        outlineColor: theme.palette.primary.main,
                        color: theme.palette.primary.main,
                        backgroundColor: 'transparent',
                    },
                    ':hover': {
                        backgroundColor: theme.palette.action.hover,
                    },
                    '&.Mui-selected, &.Mui-selected:focus': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        '&:hover': {
                            backgroundColor: theme.palette.primary.hover,
                        },
                        '&:active': {
                            backgroundColor: theme.palette.primary.active,
                        },
                    },
                },
                '.MuiMonthCalendar-root, .MuiYearCalendar-root': {
                    padding: theme.spacing(0.5, 2),
                    gap: theme.spacing(1.5),
                    maxWidth: calendarWidth,
                },
                '.MuiPickersDay-dayOutsideMonth': {
                    color: theme.palette.text.disabled,
                },
                '.MuiPickersLayout-actionBar': {
                    padding: theme.spacing(2),
                    paddingTop: 0,
                },
                '.MuiPickersDay-dayHighlighted:after': {
                    // Create a dot for highlighted days, that is in the bottom center of the cell
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: '50%',
                    bottom: 2,
                    content: '""',
                    height: 5,
                    left: '50%',
                    position: 'absolute',
                    transform: 'translateX(-50%)',
                    width: 5,
                },
                '.MuiPickersDay-dayHighlighted.Mui-selected:after': {
                    backgroundColor: theme.palette.primary.contrastText,
                },
                // Hide MUI digital clock selection as we have our own
                '.MuiMultiSectionDigitalClock-root': {
                    display: 'none',
                },
                '.MuiPickersCalendarHeader-label': {
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                },
            });
        },
    },
};
